// Console ASCII Art - Easter egg for developers
export const displayConsoleArt = () => {
    // Detect if DevTools is open
    const devtools = { open: false };
    const threshold = 160;

    // Check if devtools is open based on window size
    const checkDevTools = () => {
        const widthThreshold = window.outerWidth - window.innerWidth > threshold;
        const heightThreshold = window.outerHeight - window.innerHeight > threshold;

        if (!(heightThreshold && widthThreshold) && ((window.Firebug && window.Firebug.chrome && window.Firebug.chrome.isInitialized) || widthThreshold || heightThreshold)) {
            if (!devtools.open) {
                devtools.open = true;
                showWelcomeMessage();
            }
        } else {
            devtools.open = false;
        }
    };

    const showWelcomeMessage = () => {
        // Clear console for dramatic effect
        console.clear();

        // ASCII Art Logo
        const logo = `
%c██╗  ██╗   ██╗ ██████╗    ██╗      ██████╗  ██████╗ ██╗███████╗████████╗██╗ ██████╗███████╗
%c██║ ██╔╝   ██║██╔════╝    ██║     ██╔═══██╗██╔════╝ ██║██╔════╝╚══██╔══╝██║██╔════╝██╔════╝
%c█████╔╝    ██║██║         ██║     ██║   ██║██║  ███╗██║███████╗   ██║   ██║██║     ███████╗
%c██╔═██╗    ╚═╝██║         ██║     ██║   ██║██║   ██║██║╚════██║   ██║   ██║██║     ╚════██║
%c██║  ██╗██╗    ╚██████╗    ███████╗╚██████╔╝╚██████╔╝██║███████║   ██║   ██║╚██████╗███████║
%c╚═╝  ╚═╝╚═╝     ╚═════╝    ╚══════╝ ╚═════╝  ╚═════╝ ╚═╝╚══════╝   ╚═╝   ╚═╝ ╚═════╝╚══════╝
`;

        const styles = [
            'color: #3b82f6; font-weight: bold; font-size: 12px; line-height: 1.2;',
            'color: #3b82f6; font-weight: bold; font-size: 12px; line-height: 1.2;',
            'color: #60a5fa; font-weight: bold; font-size: 12px; line-height: 1.2;',
            'color: #60a5fa; font-weight: bold; font-size: 12px; line-height: 1.2;',
            'color: #93c5fd; font-weight: bold; font-size: 12px; line-height: 1.2;',
            'color: #93c5fd; font-weight: bold; font-size: 12px; line-height: 1.2;',
        ];

        console.log(logo, ...styles);

        // Welcome message
        console.log(
            '%c👋 Hey there, Developer!',
            'color: #10b981; font-size: 20px; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.3);'
        );

        console.log(
            '%cWelcome to K&C Logistics - The Neural Network of Modern Supply Chains',
            'color: #6b7280; font-size: 14px; font-style: italic; margin-top: 10px;'
        );

        console.log('\n');

        // System Info
        console.log('%c🚀 System Information', 'color: #f59e0b; font-size: 16px; font-weight: bold;');
        console.log('%c├─ Version: 2.0.0', 'color: #8b5cf6; font-size: 12px;');
        console.log('%c├─ Environment: ' + import.meta.env.MODE, 'color: #8b5cf6; font-size: 12px;');
        console.log('%c├─ Build: Production', 'color: #8b5cf6; font-size: 12px;');
        console.log('%c└─ Status: All Systems Operational ✓', 'color: #10b981; font-size: 12px;');

        console.log('\n');

        // Tech Stack
        console.log('%c⚡ Tech Stack', 'color: #f59e0b; font-size: 16px; font-weight: bold;');
        console.log('%c├─ React 18 + TypeScript', 'color: #06b6d4; font-size: 12px;');
        console.log('%c├─ tRPC + React Query', 'color: #06b6d4; font-size: 12px;');
        console.log('%c├─ Framer Motion', 'color: #06b6d4; font-size: 12px;');
        console.log('%c├─ OpenLayers (Maps)', 'color: #06b6d4; font-size: 12px;');
        console.log('%c├─ TailwindCSS + shadcn/ui', 'color: #06b6d4; font-size: 12px;');
        console.log('%c└─ Socket.io (Real-time)', 'color: #06b6d4; font-size: 12px;');

        console.log('\n');

        // Interested in joining?
        console.log(
            '%c💼 Interested in joining our team?',
            'color: #ec4899; font-size: 16px; font-weight: bold;'
        );
        console.log(
            '%cWe\'re always looking for talented developers!',
            'color: #6b7280; font-size: 12px;'
        );
        console.log(
            '%c📧 Email: careers@kclogistics.mw',
            'color: #3b82f6; font-size: 12px; font-weight: bold;'
        );

        console.log('\n');

        // Security Warning
        console.log(
            '%c⚠️ SECURITY WARNING',
            'background: #ef4444; color: white; font-size: 18px; font-weight: bold; padding: 10px; border-radius: 5px;'
        );
        console.log(
            '%cDo NOT paste any code here unless you know what you\'re doing!\nScammers may try to trick you into running malicious code.',
            'color: #ef4444; font-size: 14px; font-weight: bold; margin-top: 5px;'
        );

        console.log('\n');

        // Fun fact
        console.log('%c💡 Fun Fact:', 'color: #8b5cf6; font-size: 14px; font-weight: bold;');
        console.log(
            '%cThis platform processes over 1,200+ deliveries across Malawi 🇲🇼',
            'color: #6b7280; font-size: 12px;'
        );

        console.log('\n');
        console.log('%c─'.repeat(80), 'color: #374151;');
        console.log('\n');
    };

    // Check on load
    checkDevTools();

    // Check periodically
    setInterval(checkDevTools, 1000);
};

// Alternative simpler version that just shows on page load
export const displaySimpleConsoleArt = () => {
    const logo = `
%c██╗  ██╗   ██╗ ██████╗    ██╗      ██████╗  ██████╗ ██╗███████╗████████╗██╗ ██████╗███████╗
%c██║ ██╔╝   ██║██╔════╝    ██║     ██╔═══██╗██╔════╝ ██║██╔════╝╚══██╔══╝██║██╔════╝██╔════╝
%c█████╔╝    ██║██║         ██║     ██║   ██║██║  ███╗██║███████╗   ██║   ██║██║     ███████╗
%c██╔═██╗    ╚═╝██║         ██║     ██║   ██║██║   ██║██║╚════██║   ██║   ██║██║     ╚════██║
%c██║  ██╗██╗    ╚██████╗    ███████╗╚██████╔╝╚██████╔╝██║███████║   ██║   ██║╚██████╗███████║
%c╚═╝  ╚═╝╚═╝     ╚═════╝    ╚══════╝ ╚═════╝  ╚═════╝ ╚═╝╚══════╝   ╚═╝   ╚═╝ ╚═════╝╚══════╝
`;

    console.log(
        logo,
        'color: #3b82f6; font-weight: bold; font-size: 10px;',
        'color: #3b82f6; font-weight: bold; font-size: 10px;',
        'color: #60a5fa; font-weight: bold; font-size: 10px;',
        'color: #60a5fa; font-weight: bold; font-size: 10px;',
        'color: #93c5fd; font-weight: bold; font-size: 10px;',
        'color: #93c5fd; font-weight: bold; font-size: 10px;'
    );

    console.log(
        '%c👋 Welcome to K&C Logistics | Built by CODE1407 🇲🇼',
        'color: #10b981; font-size: 14px; font-weight: bold;'
    );

    console.log(
        '%c⚠️ WARNING: Do not paste code here! Scammers may try to steal your account.',
        'background: #ef4444; color: white; font-size: 12px; font-weight: bold; padding: 5px; margin-top: 10px;'
    );
};
